import { ExerciseModel } from './ExerciseModel';

export class BreakdownModel extends ExerciseModel {
    constructor(breakdownData) {
        super(breakdownData);

        this._breakdown = {
            ...this._exercise,
            id: breakdownData.id,
            workoutId: breakdownData.workout_id,
            exerciseId: breakdownData.exercise_id,
            exerciseName: breakdownData.exercise_name,
            kgCount: breakdownData.KG_count,
            repsCount: breakdownData.REPS_count,
            caloriesCount: breakdownData.calories_count,
            distance: breakdownData.distance,
            time: breakdownData.timer_value,
            discipline: breakdownData.discipline,
            setNumber: breakdownData.set_number,
            isRound: breakdownData.is_round,
            quant: breakdownData.quant,
            freestyle: breakdownData.freestyle,
            type: breakdownData.type,
        };
    }

    get breakdown() {
        return this._breakdown;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/BreakdownModel.js